import { createApiOpt } from './utils';

const localName = 'user';

/**
 * 用户信息
 * @param data
 *  sint64 id = 1;  // 注：前端通过context上下文传值
 * @return res
 */
export function apiGetPlayer(data) {
  return createApiOpt(localName, 'GetPlayer', data, {
    reqDesction: 'PlayerReq',
    resDesction: 'PlayerRes',
  });
}

/**
 * 请求playerInfo, 1次最多取50个 (取代http=11协议)
 * @param data
    repeated int64 ids = 1;
 * @return res
    repeated PlayerInfo list = 1;
 */
export function apiGetPlayerInfoList(data) {
  return createApiOpt(localName, 'GetPlayerInfoList', data, {
    reqDesction: 'PlayerInfoListReq',
    resDesction: 'PlayerInfoListRes',
  });
}

/**
 * 获取玩家基础信息列表
 * @param data
    repeated int64 ids = 1;
 * @return res
    repeated SimplePlayer list = 1;
 */
export function apiSimplePlayerList(data) {
  return createApiOpt(localName, 'SimplePlayerList', data);
}

/**
 * 是否设置过密码
 */
export function apiHadWithdrawalPassword(data) {
  return createApiOpt(localName, 'HadWithdrawalPassword', data);
}

/**
 * 歌手、声优认证协议
 * @param data
    sint64 player_id = 1;       // 成员id
    sint32 level = 2;           // 等级
    AuthType auth_type = 3;     // 认证类型
      AuthTypeNone = 0;           // 无认证
      AuthTypeSinger = 1;         // 歌手认证
      AuthTypeVoicer = 2;         // 声优认证
      AuthTypeSurface = 3;        // 颜值认证
    bool is_set = 4;            // true为设置认证，false为删除认证
 */
export function apiAuthClan(data) {
  return createApiOpt(localName, 'AuthClan', data);
}

/**
 * 撤销申请
 * @param data
  WithdrawalType type = 1; // 撤销房间/个人/家族提现
  int64          id   = 2;

  @returns
  空
 */
export function apiCancelWithdrawal(data) {
  return createApiOpt(localName, 'CancelWithdrawal', data);
}

/**
 * 申请提现检测
 * @param data
 */
export function apiWithdrawCheck(data) {
  return createApiOpt(localName, 'WithdrawCheck', data);
}

/**
 * 个人申请佣金
 * @param data
 */
export function apiWithdrawDiamand(data) {
  return createApiOpt(localName, 'WithdrawDiamand', data);
}

/**
 * 房间申请佣金
 * @param data
 */
export function apiRoomWithdrawDiamand(data) {
  return createApiOpt(localName, 'RoomWithdrawDiamand', data);
}

/**
 * 设置提现密码
 * @param data
 */
export function apiSettingPasswd(data) {
  return createApiOpt(localName, 'SettingPasswd', data);
}

/**
 * 钻石兑换金币修改密码
 * @param data
 */
export function apiDiamondChangePwd(data) {
  return createApiOpt(localName, 'DiamondChangePwd', data);
}

/**
 * 获取四个收益
 * @param data
 */
export function apiH5PlayerGains(data) {
  return createApiOpt(localName, 'H5PlayerGains', data, {
    reqDesction: 'GetPlayerGainsReq',
    resDesction: 'GetPlayerGainsRes',
  });
}

/**
 * 个人佣金和房间佣金记录
 * @param data
 */
export function apiWithdrawalLog(data) {
  return createApiOpt(localName, 'WithdrawalLog', data);
}

/**
 * 查看个人/房间佣金记录总收益
 * @param data
 */
export function apiH5TatolGain(data) {
  return createApiOpt(localName, 'H5TatolGain', data, {
    reqDesction: 'GetTatolGainReq',
    resDesction: 'GetTatolGainRes',
  });
}

/**
 * 绑定银行卡
 * @param data
 */
export function apiBindBankInfo(data) {
  return createApiOpt(localName, 'BindBankInfo', data);
}

/**
 * 获取钻石兑换金币的套餐配置
 * @param data
 */
export function apiGetDiamondChangList(data) {
  return createApiOpt(localName, 'GetDiamondChangList', data, {
    reqDesction: 'DiamondChangListReq',
    resDesction: 'DiamondChangListRes',
  });
}

/**
 * 检查提现密码是否正确
 * @param data
 */
export function apiCheckWithdrawalPassword(data) {
  return createApiOpt(localName, 'CheckWithdrawalPassword', data);
}

/**
 * 授权web登录
 * @param data
 */
export function apiAuthReqTokenConfirm(data) {
  return createApiOpt(localName, 'AuthReqTokenConfirm', data);
}

/**
 * 请求app验证登录
 * @param data
 */
export function apiGetNewAuthToken(data) {
  return createApiOpt(localName, 'GetNewAuthToken', data, {
    reqDesction: 'NewAuthTokenReq',
    resDesction: 'NewAuthTokenRes',
  });
}

/**
 * 获取用户信息
 * @param data
    sint64 player_id = 1;
    ChongZhiType type = 2;
      ChongZhiType_Zero = 0; // 不使用
      ChongZhiType_Weixin = 1; // 微信
      ChongZhiType_Zhifubao = 2; // 支付宝
      ChongZhiType_Union = 3; // 银联
      ChongZhiType_HalfWeixin = 4; // 半屏微信
      ChongZhiType_HalfZhifubao  = 5; // 半屏支付宝
      ChongZhiType_PcZhifubao  = 6; // pc支付宝
      ChongZhiType_PcWeixin  = 7; // pc微信
      ChongzhiType_InnerZhifubao = 8;//支付宝内购
      ChongzhiType_InnerWeixin = 9;//微信内购
 * @return res
 */
export function apiGetSimplePlayer(data) {
  return createApiOpt(localName, 'GetSimplePlayer', data);
}

/**
 * 获取充值套餐
 * @param data
    sint64 player_id = 1;
    ChongZhiType type = 2;
      ChongZhiType_Zero = 0; // 不使用
      ChongZhiType_Weixin = 1; // 微信
      ChongZhiType_Zhifubao = 2; // 支付宝
      ChongZhiType_Union = 3; // 银联
      ChongZhiType_HalfWeixin = 4; // 半屏微信
      ChongZhiType_HalfZhifubao  = 5; // 半屏支付宝
      ChongZhiType_PcZhifubao  = 6; // pc支付宝
      ChongZhiType_PcWeixin  = 7; // pc微信
      ChongzhiType_InnerZhifubao = 8;//支付宝内购
      ChongzhiType_InnerWeixin = 9;//微信内购
 * @return res
 */
export function apiGetChongZhi(data) {
  return createApiOpt(localName, 'GetChongZhi', data);
}

/**
 * 获取用户信息
 * @param data
    int64 player_id = 1; // 用户ID
 * @return res
 */
export function apiGetCanRechargeCredit(data) {
  return createApiOpt(localName, 'GetCanRechargeCredit', data, {
    reqDesction: 'CanRechargeCreditReq',
    resDesction: 'CanRechargeCreditRes',
  });
}

/**
 * 鉴权的获取充值配置接口
 * @param data
    sint64 player_id = 1;
    ChongZhiType type = 2;
      ChongZhiType_Zero = 0; // 不使用
      ChongZhiType_Weixin = 1; // 微信
      ChongZhiType_Zhifubao = 2; // 支付宝
      ChongZhiType_Union = 3; // 银联
      ChongZhiType_HalfWeixin = 4; // 半屏微信
      ChongZhiType_HalfZhifubao  = 5; // 半屏支付宝
      ChongZhiType_PcZhifubao  = 6; // pc支付宝
      ChongZhiType_PcWeixin  = 7; // pc微信
      ChongzhiType_InnerZhifubao = 8;//支付宝内购
      ChongzhiType_InnerWeixin = 9;//微信内购
 * @return res
 */
export function apiChongZhiConfig(data) {
  return createApiOpt(localName, 'ChongZhiConfig', data, {
    reqDesction: 'GetChongZhiReq',
    resDesction: 'GetChongZhiRes',
  });
}

/**
 * 获取不用鉴权的开关
 * @param data
    DeviceType device  = 1;
    string     version = 2; // 6.5.0
 * @return res
 */
export function apiGetNoAuthBeforeLogin(data) {
  return createApiOpt(localName, 'GetNoAuthBeforeLogin', data);
}

/**
 * 获取授权结果
 * @param data
    string auth_req_token = 1;
 * @return res
 */
export function apiGetAuthReqResult(data) {
  return createApiOpt(localName, 'GetAuthReqResult', data, {
    reqDesction: 'AuthReqResultReq',
    resDesction: 'AuthReqResultRes',
  });
}

/**
 * 获取开关状态
 * @param data
 */
export function apiGetOnOffList(data) {
  return createApiOpt(localName, 'GetOnOffList', data);
}

/**
 * 获取用户实名认证的信息
 * @param data
 */
export function apiCertificationInfo(data) {
  return createApiOpt(localName, 'CertificationInfo', data);
}

/**
 * 获取房间收益
 * @param data
 */
export function apiH5RoomGiftTicket(data) {
  return createApiOpt(localName, 'H5RoomGiftTicket', data, {
    reqDesction: 'RoomGiftTicketReq',
    resDesction: 'RoomGiftTicketRes',
  });
}

/**
 * 查询银行卡信息
 * @param data
 * @return res
  *string card_num = 1;	// 银行卡帐号
    string mayuncount = 2;	// 支付宝帐号
    string user_name = 3;	// 用户名字
    string identity_code = 4;	// 身份证号
    string bank_name = 5;	// 开户行
    string sub_name = 6;	// 开户支行
    string phone = 7;	// 手机号
    bool is_agreement = 8;	// 是否同意劳务协议
    int64 agreement_at = 9;	// 同意劳务协议的时间戳，秒
    sint32 is_notice = 10;  // 是否需要弹出修改协议通知 0需要 1不需要 ;
    int64 notice_at = 11;  // 第一次同意新协议时间
 */
export function apiBankInfo(data) {
  return createApiOpt(localName, 'BankInfo', data);
}

/**
 * 个人兑换金币
 * @param data
 */
export function apiDiamondChangCoin(data) {
  return createApiOpt(localName, 'DiamondChangCoin', data);
}

/**
 * 房间兑换金币
 * @param data
 */
export function apiRoomChangeCoin(data) {
  return createApiOpt(localName, 'RoomChangeCoin', data);
}

/**
 * 获取捞鲸状态
 * @param data
 */
export function apiWhaleBossStatus(data) {
  return createApiOpt(localName, 'WhaleBossStatus', data);
}

/**
 * 捞鲸老板列表
 * @param data
 */
export function apiWhaleBossList(data) {
  return createApiOpt(localName, 'WhaleBossList', data);
}

/**
 * 捞鲸请求
 * @param data
 */
export function apiCatchWhaleBoss(data) {
  return createApiOpt(localName, 'CatchWhaleBoss', data);
}

/*
 * 提现额度
 * @param data
 */
export function apiUserMonthWithdrawRemain(data) {
  return createApiOpt(localName, 'UserMonthWithdrawRemain', data);
}

/**
 * 上次代收款人信息
 * @param data
 */
export function apiUserReplaceWithdrawInfo(data) {
  return createApiOpt(localName, 'UserReplaceWithdrawInfo', data);
}

/**
 * 获取代收短信验证码
 * @param data
 */
export function apiReplaceWithdrawSmsCode(data) {
  return createApiOpt(localName, 'ReplaceWithdrawSmsCode', data);
}

/**
 * 代收提现
 * @param data
  ReplaceWithdrawType withdraw_type = 1; // 提现类型
  sint32 withdraw_num = 2;               // 提现金额
  string sms_code = 3;                   // 短信验证码
  UserReplaceWithdrawInfo user_info = 4; // 代收款人信息
  bool is_agreement = 5;                 // 是否同意条款
 */
export function apiReplaceWithdraw(data) {
  return createApiOpt(localName, 'ReplaceWithdraw', data);
}

/**
 * 代收款人信息列表
 * @param data
 * @return res
    repeated UserReplaceWithdrawInfo user_info_list = 1; // 代收款人列表
      string user_name = 1;     // 真实姓名
      string identity_code = 2; // 身份证号
      string sub_name = 3;      // 开户支行
      string phone = 4;         // 手机号
      string card_no = 5;       // 银行卡号
      string bank_name = 6;     // 开户银行
 */
export function apiUserReplaceWithdrawInfoList(data) {
  return createApiOpt(localName, 'UserReplaceWithdrawInfoList', data);
}

/**
 * 换绑银行卡信息
 * @param data
 * 	string old_phone = 1; //原银行卡手机号
  string name = 2; //姓名
  string identity_card_no = 3; //身份证号码
  string old_bank_card = 4; //原银行卡号
  string new_phone = 5; //换绑新手机号
  string new_bank_card = 6; //银行卡号
  string open_bank = 7; //开户支行
  string account_bank = 8; //开户银行
 * @return res
  UserCode ret = 1;
 */
export function apiChangeBankBind(data) {
  return createApiOpt(localName, 'ChangeBankBind', data);
}

/**
* 修改绑定手机
* @param data
  string identity_card_photo = 1; //身份证自拍
  string phone = 2; //新手机号
* @return res
UserCode ret = 1;
*/
export function apiUpdateBindPhone(data) {
  return createApiOpt(localName, 'UpdateBindPhone', data);
}

/**
* 忘记密码，未登录app，变了手机
* @param data
  string new_passwd1 = 1; // 新密码
  string new_passwd2 = 2; // 确认新密码
  string name = 3;				//姓名
  string identity_card_no = 4; //身份证号码
  string identity_card_photo = 5; //身份证自拍
  int64 id = 6; //用户ID
  string phone = 7; //新手机号
* @return res
UserCode ret = 1;
*/
export function apiGetUpdatePasswdChangePhone(data) {
  return createApiOpt(localName, 'GetUpdatePasswdChangePhone', data, {
    reqDesction: 'UpdatePasswdChangePhoneReq',
    resDesction: 'UpdatePasswdChangePhoneRes',
  });
}

/**
* 修改兑换密码
* @param data
  string new_passwd1 = 1; // 新兑换密码
  string new_passwd2 = 2; // 确认新兑换密码
  string name = 3;				//姓名
  string identity_card_no = 4; //身份证号码
  string identity_card_photo = 5; //身份证自拍
  string card_num = 6; //银行卡号
  string phone = 7; //绑定银行卡手机号
* @return res
UserCode ret = 1;
*/
export function apiChangeExchangePasswd(data) {
  return createApiOpt(localName, 'ChangeExchangePasswd', data);
}

/**
* 用户该类型申诉是否进行中
* @param data
  int64 id = 1; //用户ID
  CheckType type = 2; //申诉类型

  enum CheckType{
  CHECK_NONE = 0;
  CHECK_CHANGE_PWD = 1; //修改登录密码
  CHECK_BIND_PHONE = 2; //修改绑定手机
  CHECK_CHANGE_EXCHANGE_PWD = 3; //修改兑换密码
  CHECK_BIND_BANK = 4; //换绑银行卡
}

* @return res
UserCode ret = 1;
*/
export function apiGetIsChecking(data) {
  return createApiOpt(localName, 'GetIsChecking', data, {
    reqDesction: 'IsCheckingReq',
    resDesction: 'IsCheckingRes',
  });
}

/**
* 获取实名认证信息实名认证成功H5回调
* @param data
  string certify_id = 1;
}

* @return res
  string name = 2; // 用户姓名
  string identity_card_no = 3;	// 打码的用户身份证号
*/
export function apiGetCertificationInfo(data) {
  return createApiOpt(localName, 'GetCertificationInfo', data, {
    reqDesction: 'IsCheckingReq',
    resDesction: 'IsCheckingRes',
  });
}

/**
* 获取用户是否实名认证信息
* @param data
  int64 id = 1; //用户id

}

* @return res
  bool flag = 1; // true：已认证 ； flag：未认证

*/
export function apiGetCertification(data) {
  return createApiOpt(localName, 'GetCertification', data);
}

/**
 * 更新提现协议提示状态
 * @param data
 * @return res
 */
export function apiUpdateWithdrawNoticeStatus(data) {
  return createApiOpt(localName, 'UpdateWithdrawNoticeStatus', data);
}

/**
 * 点击提现协议发送验证码
 * @param data
 * @return res
 */
export function apiWithdrawProtocolSendCode(data) {
  return createApiOpt(localName, 'WithdrawProtocolSendCode', data);
}

/**
* 点击提现协议发送验证码
* @param data
  string code = 1;
* @return res
  string user_name = 1;     // 真实姓名
  string identity_code = 2; // 身份证号
*/
export function apiWithdrawProtocolConfirmCode(data) {
  return createApiOpt(localName, 'WithdrawProtocolConfirmCode', data);
}

/** 获取亲密粉丝牌子列表
 * @params
 *   int32 page = 1;
  int32 page_size = 2;
 * @returns
	int64 used_player_id = 1; // 当前正在使用的亲密粉丝名牌ID, 小于等于0表示未佩戴
	repeated IntimateFansCardInfoV2 card_list = 2; // 名牌信息

 */
export const apiIntimateFansCardInfoV2 = (data) =>
  createApiOpt('user', 'IntimateFansCardInfoV2', data, {
    reqDesction: 'IntimateFansCardInfoVsn2Req',
    resDesction: 'IntimateFansCardInfoVsn2Res',
  });

/** 佩戴亲密粉丝牌子
 * @params
	int64 player_id = 1; // 名牌ID
 * @returns
	int64 player_id = 1; // 成功佩戴的牌子ID
 */
export const apiSetIntimateFansCard = (data) => createApiOpt('user', 'SetIntimateFansCard', data);

/** 退出粉丝团
 * @params
	int64 player_id = 1;            //  主播id
 * @returns
 */
export const apiExitIntimateFans = (data) => createApiOpt('user', 'ExitIntimateFans', data);

/** 获取亲密粉丝2.0等级配置
 * @params

 * @returns
	repeated IntimateFansVsn2LevConf conf_list = 1;

 */
export const apiIntimateFansVsn2LevConf = (data) => createApiOpt('user', 'IntimateFansVsn2LevConf', data);

/**
 * @params
	repeated int64 player_ids = 1; // 亲密粉丝主播id数组

 * @returns
	repeated IntimateFansDetailInfo info_list = 1; // 用户与主播亲密粉丝团信息
 */
export const apiIntimateFansDetailVsn2 = (data) => createApiOpt('user', 'IntimateFansDetailVsn2', data);

/** 主播查看自己亲密粉丝信息
 * @params
	int32 index = 1; //  初始传0，-1没有了不用再请求
 * @returns
  	IntimateFansHostInfo host_info = 1; // 主播信息
	IntimateFansCardSetting card_setting = 2; // 名牌信息设置
	repeated IntimateFanInfo fan_list = 3; // 粉丝列表
	int32 next_index = 4; // 下次请求返回
 */
export const apiIntimateFansHostView = (data) => createApiOpt('user', 'IntimateFansHostView', data);

/** 设置亲密粉丝名牌
 * @params
	string card_name = 1; // 名牌名称
 * @returns
	IntimateFansCardSetting card_setting = 1; // 名牌信息设置

 */
export const apiSetIntimateFansCardInfo = (data) => createApiOpt('user', 'SetIntimateFansCardInfo', data);
/**
* 获取用户收集清单
* @param data
		ParentCollectionBillType parent_type = 1; // 父类型
		TimeCollectionBillType time_type = 2; // 时间区间
* @return res
	map<int32, CollectionBillList> bill_map = 1;

*/
export function apiCollectionPersonBill(data) {
  return createApiOpt(localName, 'CollectionPersonBill', data);
}

/**
 * 获取钻石兑换金币记录
 * @params { Object } data {
 * 	int32 page = 1; // 页数
	int32 page_size = 2; // 页面条数
	int32 year = 3; // 年
	int32 month = 4; // 月
 *     }
 * @returns { Object }  {
 }	int64 sum = 1; // 累计兑换
	repeated DiamondToCoinLog log_list = 2; // 记录列表
	int32 total = 3; // 记录总数
 */
export function apiDiamondToCoinLogs(data) {
  return createApiOpt(localName, 'DiamondToCoinLogs', data);
}

/**
   * 兑换佣金（钻石兑换佣金）
   * @params { Object } data {
    int64 num = 1; // 需要兑换的数量
   *     }
   * @returns { Object }  {

   */
export function apiExchangeToDeposit(data) {
  return createApiOpt(localName, 'ExchangeToDeposit', data);
}

/**
   * 获取钻石兑换佣金记录
   * @params { Object } data {
    int32 page = 1; // 页数
    int32 page_size = 2; // 页面条数
    int32 year = 3; // 年
    int32 month = 4; // 月
   *     }
   * @returns { Object }  {
    int64 sum = 1; // 累计兑换
    repeated DiamondToDepositLog log_list = 2; // 记录列表
    int32 total = 3; // 记录总数
   */
export function apiDiamondToDepositLogs(data) {
  return createApiOpt(localName, 'DiamondToDepositLogs', data);
}

/**
   * 获取佣金冻结记录
   * @params { Object } data {
  int32 page = 1; // 页数
    int32 page_size = 2; // 页面条数
   *     }
   * @returns { Object }  {
    int64 sum = 1; // 累计冻结
    repeated FreezeDepositLog log_list = 2; // 记录列表
    int32 total = 3; // 记录总数
   */
export function apiFreezeDepositLogs(data) {
  return createApiOpt(localName, 'FreezeDepositLogs', data);
}

/**
 * 获取房间钻石兑换金币记录
 * @params { Object } data {
	int32 page = 1; // 页数
	int32 page_size = 2; // 页面条数
	int32 year = 3; // 年
	int32 month = 4; // 月
 *     }
 * @returns { Object }  {
	int64 sum = 1; // 累计兑换
	repeated DiamondToCoinLog log_list = 2; // 记录列表
	int32 total = 3; // 记录总数
 */
export function apiRoomDiamondToCoinLogs(data) {
  return createApiOpt(localName, 'RoomDiamondToCoinLogs', data);
}

/**
 * 兑换佣金（房间钻石兑换佣金）
 * @params { Object } data {
	int64 num = 1; // 需要兑换的数量

 *     }
 * @returns { Object }  {
 */
export function apiRoomExchangeToDeposit(data) {
  return createApiOpt(localName, 'RoomExchangeToDeposit', data);
}

/**
 * 获取房间钻石兑换佣金记录
 * @params { Object } data {
	int32 page = 1; // 页数
	int32 page_size = 2; // 页面条数
	int32 year = 3; // 年
	int32 month = 4; // 月
 *     }
 * @returns { Object }  {
	int64 sum = 1; // 累计兑换
 * 	repeated DiamondToDepositLog log_list = 2; // 记录列表
	int32 total = 3; // 记录总数
 */
export function apiRoomDiamondToDepositLogs(data) {
  return createApiOpt(localName, 'RoomDiamondToDepositLogs', data);
}

/**
 * 用户身份信息审核
 * @params { Object } data {
	string name = 1; // 姓名
	string certify_no = 2; // 身份证号
	string img_a = 3; // 身份证正面
	string img_b = 4; // 身份证背面
 *     }
 * @returns { Object }  {
 */
export function apiUploadCertifySource(data) {
  return createApiOpt(localName, 'UploadCertifySource', data);
}

/**
 * 充值优惠记录信息列表
 * @params { }
  bool is_inner = 1; // 站内为true，站外为false

 * @returns { Array }
 * repeated ChargeBonusLog log_list = 1;
 *
  message ChargeBonusLog{
    int64 player_id = 1; // 用户id
    int64 player_sid = 2; // 用户短号
    string player_name = 3; // 用户名称
    string player_icon = 4; // 用户头像
    int64 charge_val = 5; // 充值金额
    int64 bonus_val = 6; // 获得奖励金币券值
  }
 */
export function apiGetChargeBonusLogs(data) {
  return createApiOpt(localName, 'GetChargeBonusLogs', data);
}

/**
 * 账号注销 注销检查
 * @params { Object } data {
 * string client_info = 1;  // 客户端信息
 *     }
 * @returns { Object }  {
 * bool account_safe = 1; // 账号处于安全状态(在最近的一个月内，没有进行过密码修改，手机换绑等敏感操作)
	bool account_ban = 2; // 非风险类账号(在最近6个月内，账号没有被封号过)
	bool money_empty = 3; // 金币和钻石余额均为0
	bool bill_order = 4;	// 账号未完成订单
	SimplePlayer player = 5; // 用户信息
	bool is_bind_phone = 6;  // 是否绑定手机
	bool is_clan_identity = 7;  // 是否是公会会长/家族族长
	bool is_ios_verity = 8;  // ios是否在审核中
	bool is_servicing_order = 9; // 是否有我接的订单
	bool is_bill_ordering = 10;  // 是否有我下的订单
	int32 keep_days = 11;  // 注销保护天数
	bool is_account_ban_freedom = 12; // 当前账号是否解封
 */
export function apiDeleteAccountCheck(data) {
  return createApiOpt(localName, 'DeleteAccountCheck', data);
}

/**
 * 账号注销 发送验证码
 * @returns { Object }  { phone: 用户绑定的手机号 }
 */
export function apiDeleteAccount(data) {
  return createApiOpt(localName, 'DeleteAccount', data);
}

/**
 * 账号注销 注销验证码确认
 * @params { Object } data { code: <验证码|string> }
 * @returns { Object }  { phone: 用户绑定的手机号 }
 */
export function apiDeleteAccountConfirm(data, key) {
  return createApiOpt(localName, 'DeleteAccountConfirm', data);
}

/**
 * 获取芝麻认证URL
 * @params
  string name = 1;  // 姓名
	string identity_card_no = 2;  // 身份证号
 * @returns
  string target_url = 1; // 跳转链接，回调的url带
	string biz_no = 2; // 芝麻认证的biz_no
 */
export function apiCertificationUrl(data, key) {
  return createApiOpt(localName, 'CertificationUrl', data);
}

/*
 * 微信公众号绑定玩家id
 * @params
  string union_id = 1;
	string open_id = 2;
	string app_id = 3;
	int64 player_id = 4;
 * @returns
  string token = 1;
 */
export function apiWeChatBindId(data) {
  return createApiOpt(localName, 'WeChatBindId', data);
}

/**
 * 解除微信公众号绑定玩家id
 * @params
  空
 * @returns
  空
 */
export function apiCancelWeChatBindId(data) {
  return createApiOpt(localName, 'CancelWeChatBindId', data);
}

/**
 * 微信公众号获取绑定玩家id列表
 * @params
  string union_id = 1;
	string open_id = 2;
	string app_id = 3;
	WeChatLogin login_type = 4;
 * @returns
  bool status = 1; // 是否已绑定成功，否的话请求 WeChatBindIdReq
	repeated WeChatBind bind_list = 2;

  enum WeChatLogin {
    WX_LOGIN_ZERO = 0;
    WX_LOGIN_PHONE = 1; // 手机登录绑定
    WX_LOGIN_ID_PSW = 2; // 账号id登录绑定
  }

  // 微信绑定账号信息
  message WeChatBind {
    int64 player_id = 1;
    string name = 2;
    string icon = 3; // 头像
  }
 */
export function apiWeChatBindList(data) {
  return createApiOpt(localName, 'WeChatBindList', data);
}

/**
 * 获取微信公众号接单大神信息
 * @params
  空
 * @returns
  int64 player_id = 1;         // 用户ID
  string name = 2;             // 用户名字
  int32 is_bill_authority = 3; // 是否有接单权限(1:有权限, 0:没权限)
  string icon = 4;             // 用户头像
 */
export function apiWechatBindInfoRpc(data) {
  return createApiOpt(localName, 'WechatBindInfoRpc', data, {
    reqDesction: 'WechatBindInfoReq',
    resDesction: 'WechatBindInfoReq',
  });
}

/**
 * 微信公众号手机验证码登录
 * @params
  string phone = 1;
	string sms_code = 2; // 验证码
 * @returns
  string token = 1;             // token
 */
export function apiGetWeChatSubLogin(data) {
  return createApiOpt(localName, 'GetWeChatSubLogin', data);
}

/**
 * 兑换金币发送验证码
 * @params
  空
 * @returns
  空
 */
export function apiChangeCoinSendCode(data) {
  return createApiOpt(localName, 'ChangeCoinSendCode', data);
}

/**
 * 获取相同实名的用户
 * @params
 * message SameCertifyUsersReq {}
 * @returns
 *  message SameCertifyUsersRes {
 *    repeated SimplePlayer player_list = 1;
 *  }
 */
export function apiSameCertifyUsers(data) {
  return createApiOpt(localName, 'SameCertifyUsers', data);
}
